import { render } from "./AboutLinkPage.vue?vue&type=template&id=a9c18aba"
import script from "./AboutLinkPage.vue?vue&type=script&lang=js"
export * from "./AboutLinkPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__